export default __webpack_public_path__ + "static/media/miguel-lopes-11.9ae3119d.jpg";